import { isHostedInWeb } from '@/utils/hostingApp';
import { Text } from '@shared/components';
import Login from '@shared/features/login/Login';
import { Auth0LoginButton } from '../Auth0/Auth0LoginButton';

const OutlookLogin = ({ webBaseUrl }: { webBaseUrl: string }) => {
  return (
    <Login
      authBaseUrl={import.meta.env.VITE_API_BASE_URL}
      displayLogo={isHostedInWeb()}
      appName="Outlook"
    >
      <div className="flex flex-wrap text-gray-700">
        <Text type="body-xs"> Forgot your password? Reset it</Text>
        <a href={webBaseUrl} target="_blank" rel="noreferrer">
          <Text
            type="body-xs"
            className="text-brand-orange-500 hover:text-underline mx-1 cursor-pointer"
          >
            here
          </Text>
        </a>
        <Text type="body-xs">(you may need to logout first).</Text>
      </div>

      <Auth0LoginButton />
    </Login>
  );
};

export default OutlookLogin;
